import React, {useContext} from 'react';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import FirebaseContext from "../../context/FirebaseContext";
import { GoogleAuthProvider, EmailAuthProvider } from "firebase/auth";
import {Navigate} from 'react-router-dom';
import logo from '../../assets/logo.png';
import wynsome from '../../assets/wynsome-creations@100h.png';
import './Login.scss';

const GOOGLE_SCOPES = [
  'https://www.googleapis.com/auth/drive.file',
];

function Login() {
  const firebaseCtx = useContext(FirebaseContext);
  const {user, auth} = firebaseCtx;

  if (user) {
    return <Navigate to="/" replace={true} />;
  } else {

    // Configure FirebaseUI.
    const uiConfig = {
      // Popup signin flow rather than redirect flow.
      signInFlow: 'popup',
      // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
      signInSuccessUrl: '/',
      // We will display Google and Facebook as auth providers.
      signInOptions: [
        {
          provider: GoogleAuthProvider.PROVIDER_ID,
          scopes: GOOGLE_SCOPES,
        },
        EmailAuthProvider.PROVIDER_ID,
      ],
      // https://github.com/firebase/firebaseui-web/#available-callbacks
      callbacks: {
        signInSuccessWithAuthResult: firebaseCtx.signInSuccess,
      }
    };
    return (
      <div className="page page-login">
        <img src={logo} className="logo-img" alt="LebSpend logo" />
        <h1>£eb$pend</h1>
        <span className="tag-line">Track your expenses against the ever changing dollar-lira rate</span>

        <p>We help you track your expenses in dollars by keeping track of every time you exchange dollars for lira and matching up each expense to the exchange rate where those lira came from.</p>
        <p>Sounds a bit tricky? Don't worry. We do all the heavy lifting.</p>
        <p>But in the end, we save all the data to a Google Sheet that you control so you can analyze your spending however you want. That also means we don't store any of your personal data.</p>
        <p className="cta">Ready to get started?</p>

        <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth}/>

        <div className="wynsome-credit">
          <span className="made-by">Created by</span>
          <img src={wynsome} className="logo-img" alt="Wynsome logo" />
        </div>
      </div>
    );
  }
}

export default Login;